"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const layout_1 = tslib_1.__importDefault(require("antd/es/layout"));
const __1 = require("..");
exports.Footer = ({ footerImage, footerImageMobile, socials, children }) => {
    return (React.createElement(layout_1.default.Footer, { className: 'clp-footer' },
        footerImage && React.createElement("img", { src: footerImage, alt: "", className: 'clp-footer__img' }),
        footerImageMobile && React.createElement("img", { src: footerImageMobile, alt: "", className: 'clp-footer__img clp-footer__img_mob' }),
        React.createElement(__1.Container, null,
            children,
            React.createElement("nav", { className: "clp-footer__social" }, socials && socials.map(item => item)),
            React.createElement("span", { className: 'clp-footer__info' },
                "\u00A9",
                new Date().getFullYear(),
                " by Cl\u00E9 Priv\u00E9e"))));
};
//# sourceMappingURL=Footer.js.map